<script lang="ts">
    import type { Writable } from 'svelte/store'

    import { gettext as _ } from 'hydria/services/gettext'
    import { sanchor, spath } from 'hydria/svelte_helpers'

    import type { PubStatus, ZoneDomainRelation } from 'wdom/zone/zone'

    interface Props {
        status: Writable<'loading' | 'ready' | 'not-found' | 'error'>
        pubStatus: Writable<PubStatus>
        zoneDomainRelation: Writable<ZoneDomainRelation>
        dsRecordsHasActive: Writable<boolean>
        class?: string | null
    }

    let { status, pubStatus, zoneDomainRelation: zdr, dsRecordsHasActive, class: classes = null }: Props = $props()

    let hasWarnings: boolean = $derived($status == 'ready' && (!$zdr.ns_consistents || (!$zdr.ds_consistents && $zdr.domain_has_ds_records) || ($zdr.domain_has_dnssec_support && $dsRecordsHasActive && !$zdr.domain_has_ds_records))),
        hasDangers: boolean = $derived($status == 'ready' && hasWarnings && !$zdr.ds_consistents)
</script>

{#if $status == 'ready' && hasWarnings && $pubStatus.published}
    <div>
        <div class="standalone-title" class:text-danger={hasDangers} class:text-warning={!hasDangers}>{$_('Related domain setup')}</div>
        <div class="card{classes ? ` ${classes}` : ''}">
            <div class="card-body">
                {#if !$zdr.ns_consistents}
                    <p>{$_('The domain related to this zone has different name servers than those defined in this zone.')}</p>
                {/if}
                {#if !$zdr.ds_consistents && $zdr.domain_has_ds_records}
                    <p class="text-danger">{$_('The DNSSEC signatures configured on the domain do not match the signatures of the zone.')}</p>
                    <p class="text-danger">{$_('If the domain has DS entries configured, it must match the signature of the zone, else the zone will literally be ignored by the clients.')}</p>
                {/if}
                {#if $zdr.domain_has_dnssec_support && $dsRecordsHasActive && !$zdr.domain_has_ds_records}
                    <p class="text-warning">{$_('DNSSEC is disabled on the domain. To enable DNSSEC, you must set the DS records on the domain with the values defined below. Alternatively, you can enable automatic synchronization of the DS records on the domain’s page.')}</p>
                {/if}
                <p>
                    <a use:sanchor href={spath(`/domain/${$zdr.idna}`)} class="btn btn-outline-secondary">{$_('Goto domain page')}</a>
                </p>
            </div>
        </div>
    </div>
{/if}
